import { render, staticRenderFns } from "./SelectOrderTemplate.vue?vue&type=template&id=c51fe578&"
import script from "./SelectOrderTemplate.vue?vue&type=script&lang=js&"
export * from "./SelectOrderTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports